import styled from "styled-components";
import {
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
} from "../../../constants/Styles";
import Link from "next/link";

export const Title = styled.div`
  cursor: pointer;
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size24};
  font-weight: ${FONT_WEIGHT.weight500};
  line-height: 2rem;
  // for very long titles
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
`;

export const SubTitle = styled.div`
  cursor: pointer;
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size18};
  font-weight: ${FONT_WEIGHT.weight500};
  line-height: 2rem;
  color: ${COLORS.secondaryLight};
  // for very long titles
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
`;

export const AuthorAndLocation = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size14};
  font-weight: ${FONT_WEIGHT.weight500};
`;

export const ElementLink = styled(Link)`
  text-decoration: none;
  color: ${COLORS.secondary};
  
  &:hover {
    color: ${COLORS.secondary};
  }
}
`;

export const Card = styled.div`
  margin: 1rem;
  box-sizing: border-box;
  width: 327px;
  height: 304px;
  padding: 1.5rem 1.5rem 2.5rem 1.5rem;
  border-radius: 1.5rem;
  background: ${COLORS.inputGray};
  position: relative;
  opacity: 0.8;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${FONT_SIZE.size13};
  font-weight: ${FONT_WEIGHT.weight500};
`;
